import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { UI } from 'components/index'
import { defaultValues } from './constants'
import { getIndicators } from 'api/Indicators'
import { getSimulation } from 'api/Simulador'
import { isProduction } from 'helpers/Utils'
import { toast } from 'react-toastify'
import { createOdooContact } from 'api/CRM'
import NewForm from './NewForm'
import Result from './Result'

const Simulador = () => {
  const [result, setResult] = useState(null)
  const [showResults, setShowResults] = useState(false)
  const [indicators, setIndicators] = useState(null)
  const [loading, setLoading] = useState(false)

  const {
    watch,
    register,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: 'onBlur',
    // TODO: Validación de formulario con Yup
    // resolver: yupResolver(handleValidationResolver()),
  })

  const {
    property_value,
    pie_value,
    credit_years,
    anual_interest,
    firstname: name,
    email,
    phone,
    currency_property_value,
    currency_pie_value,
  } = watch()

  const handleAddContact = async () => {
    try {
      const payload = {
        name,
        email,
        phone,
        mobile: phone,
        x_campana: 'Simulador: Crédito hipotecario',
      }
      // Solo funcionará en prod y no debe llevar await para que no corte la ejecución
      isProduction() && createOdooContact(payload)
    } catch (error) {
      console.error('Error al agregar contacto:', error)
    }
  }

  // Payload para simulación
  const payload = {
    sw_propiedad_divisa: currency_property_value,
    sw_pie_divisa: currency_pie_value,
    valor_propiedad: String(property_value).replaceAll('.', ''),
    valor_pie: String(pie_value).replaceAll('.', ''),
    uf: indicators?.uf,
    plazo_credito: credit_years,
    InteresNominal: anual_interest,
    broker_email: 'userEmail@pepe.com',
  }

  // Simulación con la API, se envía el payload y setea el resultado
  const handleSimulate = async () => {
    setLoading(true)
    try {
      const { data } = await getSimulation(payload)
      handleAddContact()
      setResult(data.result)
      setLoading(false)
      setShowResults(true)
      window.scrollTo(0, 0)
      return toast.success('Simulación exitosa')
    } catch (error) {
      console.error(error)
      setLoading(false)
      return toast.error('Error al simular, intente nuevamente')
    }
  }

  // Indicadores financieros para los Select de los inputs
  const fetchIndicators = async () => {
    try {
      const { data } = await getIndicators()
      setIndicators(data.result)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchIndicators()
  }, [])

  const resetSimulator = () => {
    setResult(null)
    setShowResults(false)
    reset(defaultValues)
    window.scrollTo(0, 0)
  }

  // Validación de formulario básico
  const validate = Boolean(
    property_value && pie_value && credit_years && anual_interest && name && email && phone,
  )

  return (
    <div className="flex flex-col my-6 space-y-6">
      <UI.Header
        title={showResults ? 'Resultados' : 'Simula tu crédito hipotecario'}
        subtitle={!showResults && 'y conoce el dividendo, plazos y más !'}
      />
      {!showResults && (
        <NewForm
          watch={watch}
          register={register}
          setValue={setValue}
          errors={errors}
          handleSimulate={handleSimulate}
          loading={loading}
          isDisabled={!validate}
        />
      )}
      {result && <Result result={result} resetSimulator={resetSimulator} />}
    </div>
  )
}

export default Simulador
